import React from 'react'
import Questions from '../../pages-partial/Quizzes/QuizQuestions'

const QuizQuestions = () => {
  return (
    <div><Questions /></div>
  )
}

export default QuizQuestions